import { render, staticRenderFns } from "./BalanceMoneyMenuItem.vue?vue&type=template&id=b239280e&scoped=true"
import script from "./BalanceMoneyMenuItem.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b239280e",
  null
  
)

export default component.exports